import Config from "src/Constants/Config";

import Page from "./Page";

const PageId = 0;

const DATA = () => {
  return {
    showHeader: true,
    fullScreen: true,
    children: <Page />,
    bgVideo: {
      video: `${Config.BASE_URL}/videos/bg_${PageId}.mp4`,
      poster: `${Config.BASE_URL}/images/bg_${PageId}.jpg`,
    },
  };
};

export default DATA;
